import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import store from "./store";
import config from "./config";
import Parse from "parse";

// require('@/store/subscriber')

Vue.config.productionTip = false;

Parse.initialize(config.applicationId, config.jsId);
Parse.serverURL = config.apiUrl;

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount("#app");

